
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    place: {
      type: Object,
      default: null,
    },
    search: {
      type: Object,
      default: null,
    },
    view: {
      type: String,
      default: 'card',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    expired: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    queryWithoutSession() {
      const search = this.search || this.searchQuery
      if (!search) {
        return {}
      }
      // Remove session from search query if expired
      if (this.expired && typeof search === 'object') {
        const query = { ...search }
        delete query.session
        return query
      }
      return search
    },
    path() {
      if (this.data.hotel_path && this.data.hotel.aggregator === 'innstant') {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
          params: {
            countrySlug: this.data.hotel_path.split('/')[0],
            destinationSlug: this.data.hotel_path.split('/')[1],
            hotelSlug: this.data.hotel.slug,
          },
          query: this.search || this.searchQuery,
        })
      } else {
        return this.localePath({
          name: 'hotels-place-countrySlug-hotelId',
          params: {
            countrySlug: this.data.hotel.country.slug,
            hotelId: this.data.hotel.id,
          },
          query: this.queryWithoutSession,
        })
      }
    },
    hotelCity() {
      if (this.data.hotel.aggregator === 'innstant' && this.data.hotel_path) {
        return this.data.hotel_path.split('/')[1]
      }

      return null
    },
    hotelCountry() {
      if (this.data.hotel.aggregator === 'innstant' && this.data.hotel_path) {
        return this.data.hotel_path.split('/')[0]
      }

      return this.data.hotel.country.slug
    },
  },
  methods: {
    getDistance(distance, unit = 'km') {
      let destination = this.place.name

      if (this.place.types && this.place.types.includes('locality')) {
        destination = this.$t('the center')
      }

      if (unit === 'km') {
        if (distance < 1) {
          return this.$t('{distance} m from {destination}', {
            distance: (distance * 1000).toFixed(0),
            destination,
          })
        } else {
          return this.$t('{distance} km from {destination}', {
            distance: distance.toFixed(1),
            destination,
          })
        }
      } else {
        return this.$t('{distance} mi from {destination}', {
          distance: distance.toFixed(2),
          destination,
        })
      }
    },
  },
}
